import CalloutContent from "@gaiaProfessionals/Components/HCP/CalloutContent";
import CategoryListBlock from "@gaiaProfessionals/Components/HCP/CategoryListBlock";
import LinkListMenu from "@gaiaProfessionals/Components/HCP/LinkListMenu";
import * as S from "@gaiaProfessionals/Widgets/HCP/Navigation/MasterNavigation.styles";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import Icon from "@insite/mobius/Icon";
import UploadIcon from "@insite/mobius/Icons/Upload";
import Link from "@insite/mobius/Link";
import React, { Component, useState } from 'react'

interface LinkItem {

}

interface CtaItem {
  menuType?: string;
  image: string;
  imageAlt: string;
  heading: string;
  text: string;
  destination?: { url: string };
  buttonText: string;
}

interface DataItem {
  heading: string;
  destination: string;
  buttonText: string;
}

interface MenuProps {
  callouts: any[];
  cta: CtaItem[];
  links: LinkItem[];
  menuTitle: string;
  type: string;
  data: DataItem;
}

const NavLinkList: React.FC<{menu: MenuProps, isLoggedIn: boolean}> = ({ menu, isLoggedIn }) => {


  const { callouts, cta, links, menuTitle, type, data } = menu
  // * We will render dynamic content based on the logged in status of the user
  const isProfessionalsMenu = menuTitle === 'Professionals'
  const loggedInText = 'Visit your account to update personal information, review past orders, and inspect your account details.'
  const loggedInBtnText = 'My Account'
  const loggedInBtnUrl = '/MyAccount'
  let cData

  for (const c of cta) {
    if (!c.menuType || c.menuType === 'ctas') {
      cData = c
    }
  }

  const [ isHovered, setIsHovered ] = useState(false)

  const openMenu = (): void => {
    setIsHovered(true)
  }
  const closeMenu = (): void => {
    setIsHovered(false)
  }
  const toggleMenu = (): void => {
    if (isHovered === false) {
      setIsHovered(true);
    } else {
      setIsHovered(false);
    }
  }

  return (
    <>
      <li
        className="navLinkList__item"
        onMouseEnter={openMenu}
        onMouseLeave={closeMenu}
        onFocus={openMenu}
        onBlur={closeMenu}
      >
        <Link className="navLinkList__link" href="#" aria-expanded={isHovered} onClick={toggleMenu}>{menuTitle}</Link>
        <S.NavDropDown className="dropdown dropdown--megaMenu">
          <S.MegaMenu>
            {/* <============== If Links Section ==============> */}
            {type === 'links' &&
              <div className="megaMenu__container megaMenu__container--d-column">
                <li className="megaMenu__column megaMenu__column--categories">
                    <span className="megaMenu__linkList-header">{data.heading}</span>
                    <ul className="megaMenu__categoryList">
                      {links && links.map((link: any, index: any) => (
                        <CategoryListBlock key={index} data={link} closeMenu={closeMenu}/>
                      ))}
                    </ul>
                </li>
                <li className="megaMenu__column megaMenu__column--fullButton">
                    <Link className="button" href={data.destination} onClick={closeMenu}>{data.buttonText}</Link>
                </li>
              </div>
            }

            {/* <============== If CTA Section ==============> */}
            {type === 'cta' &&
              <ul className="megaMenu__container">
                  <li className="megaMenu__column megaMenu__column--links">
                      <span className="megaMenu__linkList-header">{data.heading}</span>
                      <ul className="megaMenu__linkList">
                        {links && links.map((link: any, index: any) => (
                          <LinkListMenu key={index} data={link} closeMenu={closeMenu}/>
                        ))}
                      </ul>
                  </li>
                  <li className="megaMenu__column megaMenu__column--CTA">
                      <div className="megaMenu__container">
                          <div className="megaMenu__column">
                              <img src={cData?.image} alt={cData?.imageAlt} />
                          </div>
                          {(isLoggedIn && isProfessionalsMenu) ? (
                            <div className="megaMenu__column">
                              <span className="megaMenu__CTA-header">{cData?.heading}</span>
                              <p className="megaMenu__CTA-text">{loggedInText}</p>
                              <Link className="button" href={loggedInBtnUrl} onClick={closeMenu}>{loggedInBtnText}</Link>
                            </div>
                          ) :
                          (
                            <div className="megaMenu__column">
                              <span className="megaMenu__CTA-header">{cData?.heading}</span>
                              <p className="megaMenu__CTA-text">{cData?.text}</p>
                              <Link className="button" href={cData?.destination?.url} onClick={closeMenu}>{cData?.buttonText}</Link>
                            </div>
                          )
                          }

                      </div>
                  </li>
              </ul>
            }

            {/* <============== If Callouts Section ==============> */}
            {type === 'callouts' &&
              <ul className="megaMenu__container">
                <li className="megaMenu__column megaMenu__column--links">
                    <span className="megaMenu__linkList-header">{data.heading}</span>
                    <ul className="megaMenu__linkList">
                      {links && links.map((link: any, index: any) => (
                        <LinkListMenu key={index} data={link} closeMenu={closeMenu}/>
                      ))}
                    </ul>
                </li>
                {callouts && callouts.map((callout: any, index: any) => (
                  <CalloutContent key={index} data={callout} closeMenu={closeMenu}/>
                ))}
              </ul>
            }
          </S.MegaMenu>
        </S.NavDropDown>
      </li>
    </>
  )

}

export default NavLinkList